import React from 'react';
import { Route } from 'react-router-dom';
import { EverestHomePage, EverestJoinPage, EverestLoginPage, EverestMePage } from './component/everest';
import {
  EverestHome,
  LeagueDetail,
  LeagueList,
  MountainDetail,
  MountainList,
  MountainPeakDetail,
  MountainPeakList,
  MountainPeakMap,
  UserLogin,
  UserSignup
} from './component/everestadmin';

class RouteGroupEverest extends React.Component {
  render() {
    return (
      <>
        {/* everest */}
        <Route exact path={"/everest"} component={EverestHomePage} />
        <Route exact path={"/everest/me"} component={EverestMePage} />
        <Route exact path={"/everest/login"} component={EverestLoginPage} />
        <Route exact path={"/everest/join"} component={EverestJoinPage} />

        {/* everest-admin */}
        <Route exact path={"/everest-admin"} component={EverestHome} />
        <Route exact path={"/everest-admin/login"} component={UserLogin} />
        <Route exact path={"/everest-admin/signup"} component={UserSignup} />
        <Route exact path={"/everest-admin/mountain"} component={MountainList} />
        <Route exact path={"/everest-admin/mountain/:mountainId([0-9]+)"} component={MountainDetail} />
        <Route exact path={"/everest-admin/mountain-peak"} component={MountainPeakList} />
        <Route exact path={"/everest-admin/mountain-peak/:mountainPeakId([0-9]+)"} component={MountainPeakDetail} />
        <Route exact path={"/everest-admin/mountain-peak-map"} component={MountainPeakMap} />
        <Route exact path={"/everest-admin/league"} component={LeagueList} />
        <Route exact path={"/everest-admin/league/:leagueId([0-9])"} component={LeagueDetail} />
      </>
    );
  }
}

export { RouteGroupEverest };
